import { render, staticRenderFns } from "./twelve.vue?vue&type=template&id=1a8b2b88&scoped=true&"
import script from "./twelve.vue?vue&type=script&lang=js&"
export * from "./twelve.vue?vue&type=script&lang=js&"
import style0 from "./twelve.vue?vue&type=style&index=0&id=1a8b2b88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a8b2b88",
  null
  
)

export default component.exports